var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offer-credit"},[_c('base-card-create-offer',{on:{"addOffer":_vm.addResume}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }